import axios from 'axios'
import store from "@/store.js";
import {Toast} from 'cube-ui'
import Vue from 'vue'

const S = new Vue()
import {
  from
} from 'rxjs'
import { unencrypt} from './encrypt'
import { encrypt} from './encrypt'

let ignoreUrl = ['/login', 'config.json']
// let ignorePath = /^(\/webApi\/admin|config.json|\/login)/
let configIgnoreUrl = []
// let configIgnoreResponseUrl = []
//未登录状态 再截取到一次未登录状态后后续网络请求全部中断
// let unLoginStatus = false

function hasItem(item, tempArray) {
  for (let i = 0; i < tempArray.length; i++) {
    if (item.indexOf(tempArray[i]) >= 0) {
      return true
    }
  }
  return false
}
// require('es6-promise').polyfill();
// create an axios instance
const service = axios.create({
  timeout: 50000 // request timeout
})

// request interceptor
service.interceptors.request.use(config => {
  if (store.state.userInfo) {
    config.headers["Blade-Auth"] =  store.state.userInfo.SESSION_TOKEN; // 让每个请求携带token--['Authorization']为自定义key 请根据实际情况自行修改
  }
  // Do something before request is sent
  console.log(`config:${JSON.stringify(config.data)}`)
  // // 加密参数
  if (!hasItem(config.url, [...ignoreUrl, ...configIgnoreUrl]) && config.method !== 'get') {
    config.data = {
      data: encrypt(config.data, config.url)
    }
  }
  if (!hasItem(config.url, [...ignoreUrl, ...configIgnoreUrl]) && config.method === 'get') {
    if (config.url.indexOf('?') !== -1) {
      config.url += '&time=' + new Date().getTime()
    } else {
      config.url += '?time=' + new Date().getTime()
    }
  }

  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone interceptor
service.interceptors.response.use(
  response => {
    if (response.data && response.data.result && typeof response.data.result === 'string') {
      try{
          response.data.result = unencrypt(response.data.result)
          console.log(`result:${JSON.stringify(response.data.result)}`)
      }catch (e) {
          console.error(e);
      }
    }
    return response
  },
  error => {
    console.log('err' + error) // for debug
    S.$createToast({
      type: 'error',
      time: 1500,
      txt: error.message
    }).show()
    console.log(error.message);

    return Promise.reject(error)
  }
)

export const request$ = options => from(service(options))
export default service